import { render, staticRenderFns } from "./ModalAcao.vue?vue&type=template&id=222222b4&lang=pug&"
import script from "./ModalAcao.vue?vue&type=script&lang=js&"
export * from "./ModalAcao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports